module.exports = __webpack_public_path__ + "img/tku-logo.8fb38548.png";